import React, { useCallback } from 'react'

import { useOffer } from '../../../../hooks/offer'

import * as S from './style'
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent'
import Loading from 'src/components/Loading'
import { getSection } from 'src/hooks/useContentful/getSection'
import { eventTrack } from 'src/components/GoogleTagManager';
import { slugfy } from 'src/utils/formatters';

export default function Banner() {
	const { currentOffer } = useOffer()
	const { data, isLoading } = useFetchContent()

	const scrollToOffer = useCallback(() => {
		const el = document.querySelector('#plans')
		const yOffset = -80
		const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset

		window.scrollTo({ top: y, behavior: 'smooth' })
	}, [])

	if (isLoading || !data) return <Loading />

	const {
		mensagemBanner,
		bannerMessageColor,
		bannerTitleColor,
		landingTitulo,
		backgroundImagem,
		PrimaryButtonText,
		primaryColorButton,
		primaryButtonTextColor,
		secondaryButtonColor,
		secondaryButtonTextColor,
		secondaryButtonText,
		secondaryBtnBorder,
		hasPrimmaryBtn,
		hasSecondaryBtn
	} = getSection({ sectionName: 'landingHeader', data })
	const bannerBgImage = backgroundImagem.fields.file.url

	const openLink = () => {
		window.open('https://veloe.com.br/sobre', '_blank').focus()
	}

	return (
    <S.Container>
      <S.Content>
          <S.Title cor={bannerTitleColor}>
            {landingTitulo}
          </S.Title>
          <div>
            {hasPrimmaryBtn === true && (
              <S.Button
                background={primaryColorButton} color={primaryButtonTextColor}
                onClick={() => {
                  scrollToOffer();
                  eventTrack(
                    'veloe:institucional',
                    'clique:botao',
                    'banner:' + slugfy(PrimaryButtonText)
                  );
                }}
              >
                {PrimaryButtonText}
              </S.Button>
            )}
            {hasSecondaryBtn === true && (
              <S.Button
                background={secondaryButtonColor} color={secondaryButtonTextColor}
                onClick={openLink}>
                {secondaryButtonText}
              </S.Button>
            )}
          </div>
      </S.Content>
      <S.ImageContent>
        <S.BackgroundImage src={bannerBgImage}/>
        {currentOffer && currentOffer.intro ? (
            <S.TextIntro
              cor={bannerMessageColor}
              tamanho="Grande"
              dangerouslySetInnerHTML={{ __html: currentOffer.intro }}
            />
          ) : (
            //<S.TextIntro cor={bannerMessageColor}>{mensagemBanner}</S.TextIntro>
            <S.TextIntro cor={bannerMessageColor}>{mensagemBanner}</S.TextIntro>
          )}
      </S.ImageContent>
    </S.Container>
  );
}
